import { render, staticRenderFns } from "./ChangePhone.vue?vue&type=template&id=6d523d5b&scoped=true"
import script from "./ChangePhone.vue?vue&type=script&lang=js"
export * from "./ChangePhone.vue?vue&type=script&lang=js"
import style0 from "./ChangePhone.vue?vue&type=style&index=0&id=6d523d5b&prod&lang=scss&scoped=true"
import style1 from "./ChangePhone.vue?vue&type=style&index=1&id=6d523d5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d523d5b",
  null
  
)

export default component.exports